import { css } from '@emotion/react';
import { theme } from 'global';

export const exitDialog = css`
  .MuiDialog-paper {
    border-radius: 16px;
    max-width: 520px;

    @media screen and (max-width: ${theme.breaks.xs}px) {
      max-width: 100%;
    }
  }

  .MuiDialogContent-root {
    padding: 0 !important;
  }

  .MuiDialogActions-root {
    border-top: 1px solid ${theme.colors.neutral[100]};
    padding: 12px 16px;

    @media screen and (max-width: ${theme.breaks.xs}px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      gap: 24px;
      padding: 12px 16px 24px;
    }
  }
`;

export const exitDialogContent = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 24px 24px;
`;

export const exitDialogTitle = css`
  color: ${theme.colors.secondary};
  letter-spacing: 0.3px;
  margin: 0;
`;

export const exitDialogDescription = css`
  color: ${theme.colors.neutral[600]};
  margin: 0;
`;

export const exitDialogPrimaryButton = css`
  margin: 0 !important;
  padding: 14px 24px 15px !important;
`;
